import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_311: DocMigration = {
  maxSchemaVersion: "0.0.311",
  description: "Derive the default elevation from the elevation option set if it is not already set",
  apply(json: any): any {
    let defaultElevation = docGetDefaultElevation(json);

    if (defaultElevation) {
      return json;
    }

    const elevationOptionSet = docGetElevationOptionSet(json);

    if (!elevationOptionSet) {
      return json;
    }

    defaultElevation = json.elevations[elevationOptionSet.defaultValue];

    if (defaultElevation) {
      json.elevations[defaultElevation.id].isDefault = true;
    }

    return json;
  },
};

export default migration_0_0_311;

interface Elevation {
  id: string;
  isDefault: boolean;
}

function docGetDefaultElevation(doc: any): Elevation | undefined {
  return Object.values(doc.elevations as { [id: string]: Elevation }).find((elevation: any) => elevation.isDefault);
}

function docGetElevationOptionSet(doc: any): { defaultValue: string } | undefined {
  return doc.optionSets["elevationStyle"];
}
